/**
 * The navigation row above a detail page (task 153): a "← Back to …" pill
 * plus a link to the Overview, so a drill-down from the dashboard has a
 * way back that is not the browser's Back button.
 *
 * The back pill is `PillButton` secondary at a 44 px target (task 91): the
 * old text link on the integration pages was too small to hit on a phone.
 * It is a `Link` styled as the pill, not a button inside a link. The
 * Overview link is quieter — one primary move per row.
 */

import { Link, type LinkProps } from '@tanstack/react-router';

export const backLinkClass =
  'inline-flex min-h-11 items-center justify-center gap-2 whitespace-nowrap rounded-full px-5 text-sm font-bold ' +
  'bg-bluesphere-secondary text-bluesphere-secondaryFg transition-colors hover:bg-bluesphere-secondary/90 ' +
  'focus-visible:outline-hidden focus-visible:ring-2 focus-visible:ring-bluesphere-secondary ' +
  'focus-visible:ring-offset-2 focus-visible:ring-offset-bluesphere-bg';

const overviewLinkClass =
  'inline-flex min-h-11 items-center rounded-full px-4 text-sm text-white/70 transition-colors ' +
  'hover:bg-white/10 hover:text-white focus-visible:outline-hidden focus-visible:ring-2 ' +
  'focus-visible:ring-bluesphere-secondary focus-visible:ring-offset-2 focus-visible:ring-offset-bluesphere-bg';

export function PageNav({
  backTo,
  backLabel,
  className,
}: {
  backTo: LinkProps['to'];
  backLabel: string;
  className?: string;
}) {
  return (
    <nav aria-label="Page navigation" className={`flex flex-wrap items-center gap-2 ${className ?? ''}`}>
      <Link to={backTo} className={backLinkClass}>
        ← {backLabel}
      </Link>
      <Link to="/" className={overviewLinkClass}>
        Overview
      </Link>
    </nav>
  );
}
